import IndustryPageTemplate from "./IndustryPageTemplate";
import { lawyersData } from "@/data/lawyers";

export default function LawyersPage() {
  return <IndustryPageTemplate data={lawyersData} />;
}
